module.exports = __webpack_public_path__ + "media/images/cereale-tablet-079beff6a9afa6936bc55914a6619c20.jpg";